module.exports = new __parcel__URL__("tour-de-france.78a7ce69.jpg").toString();